import * as React from "react";
import "./Card.css";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from "../../i18n/custom.i18n";
import { LazyLoadImageCDN } from "./CDNImage";

import { OverlayContainer } from "./CardStylings";
import { getUrlCompliantName } from './cardUtils';

export const PostCard = (data: any) => {
    const { t, i18n } = useTranslation();
    const [OverlayDisplay, setOverlayDisplay] = React.useState("none");
    const overlayHeightRef = React.useRef("auto");
    let showDetails = true;

    let name = getUrlCompliantName(data.name);

    // No details page yet
    let DetailsURL = window.Paths.HOST_DETAILS;
    if (window.Settings.LOCAL_BUILD) {
        switch(window.Languages.language) {
            case "en":
                DetailsURL += window.Paths.DETAILS_URL + "post=" + name 
                break;

            default:
                DetailsURL += window.Paths.DETAILS_URL + "Lang=" + window.Languages.language + "&" + "post=" + name;
                break;
        }
    } else {
        switch(window.Languages.language) {
            case "en":
                DetailsURL += "/post/" + name;
                break;
            
            default:
                DetailsURL += "/post/" + window.Languages.language + "/" + name;
                break;
        }
    }

    return (
        <div id={name} className="library-robot-container">
            <div
                className="library-robot"
                onMouseEnter={(e: React.MouseEvent) => {
                    if(OverlayDisplay === "none") {
                        let post_title = e.currentTarget.childNodes[0] as HTMLHeadingElement;
                        let post_image = e.currentTarget.childNodes[1] as HTMLDivElement;
                        let image_padding = 17;

                        overlayHeightRef.current = (post_title.clientHeight + post_image.clientHeight + image_padding).toString();

                        setOverlayDisplay("flex");
                    }
                }}
                onMouseLeave = {(e: React.MouseEvent) => setOverlayDisplay("none")}
            >
                <h6 className="robot-title">{data.name}</h6>
                <div className="image-box-post">
                    <LazyLoadImageCDN 
                        cdnPath={window.Paths.POST_LIB_ASSETS_CDN + "controller-icon.svg"}
                        localPath={window.Paths.POST_LIB_ASSETS + "controller-icon.svg"}
                        alt={data.name}
                        libAssetsPath={window.Paths.POST_LIB_ASSETS}
                        classname={"img-robot"}
                    />
                </div>

                {showDetails && (
                    <table className="table table-striped">
                        <tbody>
                            {data.brands.length > 0 &&
                                <tr>
                                    <td>{t('filters-posts.brand')}</td>
                                    <td>{data.brands}</td>
                                </tr>
                            }
                            {data.controllers.length > 0 &&
                                <tr>
                                    <td>{t('filters-posts.controller')}</td>
                                    <td>{data.controllers.join(", ")}</td>
                                </tr>
                            }
                            {data.extensions.length > 0 &&
                                <tr>
                                    <td>{t('filters-posts.extension')}</td>
                                    <td>{data.extensions}</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                )}
            </div>

            {/* No overlay yet */}
            <OverlayContainer
                key={"overlay-" + data.name}
                height={overlayHeightRef.current}
                display={OverlayDisplay}
            >
                <div className="robot-links">
                    {
                        <a 
                            href={DetailsURL} 
                            //onClick={(e) => window.open(DetailsURL, "_blank")} 
                            target="_blank" 
                            type="button" 
                            role="button" 
                            className="btn-robot-link center-block"
                        >
                            <strong>{t('library-overlays.cardDetailsBtn')}</strong>
                        </a>
                    }
                </div>
            </OverlayContainer>
        </div>
    )
}
